import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {};

export const PopupReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.OPEN_SUCCESS_POPUP:
      return {
        ...state,
        ...payload,
      };

    case ActionTypes.CLOSE_SUCCESS_POPUP:
      return {
        ...state,
        successPopUp: {
          open: false,
        },
      };

    case ActionTypes.OPEN_RENAME_POPUP:
      return { ...state, ...payload };

    case ActionTypes.CLOSE_RENAME_POPUP:
      return {
        ...state,
        renamePopup: {
          open: false,
        },
      };

    case ActionTypes.RENAME_VIDEO_LOADING:
      return {
        ...state,
        renamePopup: {
          open: true,
          loading: payload,
        },
      };

    case ActionTypes.RENAME_VIDEO:
      return {
        ...state,
        renamePopup: {
          open: false,
          loading: false,
        },
      };

    case ActionTypes.OPEN_CONFIRMATION_POPUP:
      return {
        ...state,
        ...payload,
      };

    case ActionTypes.CLOSE_CONFIRMATION_POPUP:
      return {
        ...state,
        confirmationPopup: {
          open: false,
        },
      };

    case ActionTypes.OPEN_VIDEO_POPUP:
      return {
        ...state,
        videoPopup: {
          open: payload.status,
          videoURL: payload.videoURL,
        },
      };

    case ActionTypes.CLOSE_VIDEO_POPUP:
      return {
        ...state,
        videoPopup: {
          open: false,
          videoURL: null,
        },
      };

    case ActionTypes.OPEN_FAIL_DIALOG:
      return {
        ...state,
        failDialog: {
          open: true,
          message: payload.message,
        },
      };

    case ActionTypes.CLOSE_FAIL_DIALOG:
      return {
        ...state,
        failDialog: {
          open: false,
        },
      };

    default:
      return state;
  }
};
